// Baut aus dem DataTable-Filter-State das `filters`-Objekt für die
// Verträge-List-API (/contracts nimmt `filters` als JSON-Query-Param).
// Spalten-IDs = die `id`-Werte der Column-Defs in VertraegeTabelleRedesign.
import type { DateRangeValue } from "./table";

export function buildContractFilters(a: {
  filterValues: Record<string, string | boolean | undefined>;
  dateRangeValues: Record<string, DateRangeValue | undefined>;
}): Record<string, string> {
  const f: Record<string, string> = {};
  const set = (k: string, v?: string | boolean) => {
    if (v !== undefined && v !== "" && v !== false) f[k] = String(v);
  };
  set("f_status", a.filterValues["Status"]);
  set("f_gesellschaft", a.filterValues["Gesellschaft"]);
  set("f_vertragsart", a.filterValues["Vertragsart"]);
  set("f_risikoobjekt", a.filterValues["Risikoobjekt"]);
  set("f_bezeichnung", a.filterValues["Bezeichnung"]);
  const b = a.dateRangeValues["Beginn"];
  if (b?.von) f.f_beginn_von = b.von;
  if (b?.bis) f.f_beginn_bis = b.bis;
  const ab = a.dateRangeValues["Ablauf"];
  if (ab?.von) f.f_ablauf_von = ab.von;
  if (ab?.bis) f.f_ablauf_bis = ab.bis;
  return f;
}
